import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faXmark } from '@fortawesome/free-solid-svg-icons/faXmark';
import { faFilter } from '@fortawesome/free-solid-svg-icons/faFilter';

import ButtonGroup from 'ravenjs/lib/ButtonGroup';
import FaIcon from 'ravenjs/lib/FaIcon';
import MultiSelectCheckboxes from 'ravenjs/lib/MultiSelectCheckboxes';
import { getThemeProps } from 'ravenjs/utils/theme';
import { callFunc, getHandler } from 'ravenjs/utils/actions';

import { components } from 'react-select';
import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const FilterActionsStyled = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px;
    border-top: 1px solid ${MIGRATED_COLORS.literalF2f2f2};

    ${getThemeProps('FilterActions.styles')};
`;

const FilterContainerStyled = styled.div`
    position: relative;
    display: inline-block;
    width: 24px;
    height: 24px;
    margin-left: 8px;

    ${getThemeProps('FilterContainer.styles')};
`;

class DataViewFilter extends Component {
    static propTypes = {
        buttons: PropTypes.array,
        children: PropTypes.object,
        clearValue: PropTypes.func,
        defaultValue: PropTypes.array,
        handlers: PropTypes.object,
        id: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
    };

    static defaultProps = {
        buttons: [],
        children: {},
        clearValue: () => {},
        defaultValue: [],
        handlers: {},
    };

    constructor(props) {
        super(props);
        const { defaultValue } = props;

        this.state = {
            selectedFilters: defaultValue,
            isOpen: false,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { isOpen } = this.state;
        return !isOpen;
    }

    handleUpdateFilters = event => {
        const { id, handlers } = this.props;
        const { selectedFilters } = this.state;
        const handleDataViewFiltersOnClick = getHandler(handlers, 'handleDataViewFiltersOnClick');
        const filters = [{ label: id, value: selectedFilters }];
        callFunc(handleDataViewFiltersOnClick, filters);
        this.toggleOpen();
    };

    handleUpdateOpenFilter = () => {
        const { handlers } = this.props;
        const { isOpen } = this.state;
        const handleFilterIsOpen = getHandler(handlers, 'handleExtraCss');
        callFunc(handleFilterIsOpen, isOpen);
    };

    handleOnChange = options => {
        this.setState(
            () => ({ selectedFilters: options }),
            () => {
                if (options.length === 0) {
                    this.handleUpdateFilters();
                }
            }
        );
    };

    getDropdownButtonLabel = args => {
        const { placeholderButtonLabel, value: vals } = args;
        const { selectedFilters } = this.state;
        if ((!vals || vals.length === 0) && (!selectedFilters || selectedFilters.length === 0))
            return placeholderButtonLabel;
        if (vals && vals.length === 1) return vals[0].label;
        if (selectedFilters && selectedFilters.length === 1) return selectedFilters[0].label;
        if (vals && vals.length > 1) return `Selected: (${vals.length})`;
        if (selectedFilters && selectedFilters.length > 1)
            return `Selected: (${selectedFilters.length})`;
        return '';
    };

    toggleOpen = () => {
        this.setState(
            state => ({ isOpen: !state.isOpen }),
            () => {
                this.handleUpdateOpenFilter();
            }
        );
    };

    render() {
        const { type, buttons, handlers, ...rest } = this.props;
        const { isOpen } = this.state;
        const MenuList = props => {
            const { children, clearValue } = props;

            const buttonGroup = [
                {
                    id: buttons.length ? buttons[0].id : 'apply',
                    color: buttons.length ? buttons[0].color : 'primary',
                    icon: FaIcon,
                    label: buttons.length ? buttons[0].label : 'Apply',
                    noMinWidth: true,
                    onClick: this.handleUpdateFilters, // eslint-disable-line react/no-this-in-sfc
                    IconProps: {
                        icon: faPlus,
                    },
                    style: { fontSize: '12px' },
                },
                {
                    id: buttons.length ? buttons[1].id : 'clear',
                    color: buttons.length ? buttons[1].color : 'secondary',
                    icon: FaIcon,
                    label: buttons.length ? buttons[1].label : 'Clear',
                    noMinWidth: true,
                    onClick: clearValue,
                    IconProps: {
                        icon: faXmark,
                    },
                    style: { fontSize: '12px' },
                },
            ];

            return (
                <components.MenuList {...props}>
                    <div style={{ position: 'relative', height: '120px', overflowX: 'scroll' }}>
                        {children}
                    </div>
                    <FilterActionsStyled>
                        <ButtonGroup buttons={buttonGroup} handlers={handlers} />
                    </FilterActionsStyled>
                </components.MenuList>
            );
        };

        const DropdownButton = props => {
            return <FaIcon icon={faFilter} onClick={this.toggleOpen} />; // eslint-disable-line react/no-this-in-sfc
        };

        const customStyles = {
            container: () => ({
                boxShadow: `0 2px 15px ${MIGRATED_COLORS.literalRgba0001}`,
                paddingTop: '3px',
                borderRadius: '4px',
            }),
        };

        return type === 'column' ? (
            <FilterContainerStyled>
                <MultiSelectCheckboxes
                    components={{ MenuList, DropdownButton }}
                    onChange={this.handleOnChange}
                    getDropdownButtonLabel={this.getDropdownButtonLabel}
                    styles={customStyles}
                    menuIsOpen={isOpen}
                    rightAligned
                    onBlur={this.toggleOpen}
                    {...rest}
                />
            </FilterContainerStyled>
        ) : (
            <MultiSelectCheckboxes
                components={{ MenuList }}
                getDropdownButtonLabel={this.getDropdownButtonLabel}
                onChange={this.handleOnChange}
                styles={customStyles}
                {...rest}
            />
        );
    }
}

export default DataViewFilter;
